import { GOOGLE_MAPS_API_KEY } from './googleCloudServices';
import { INFRASTRUCTURE_API_BASE_URL, INFRASTRUCTURE_DYNAMIC_TILE_URL, INFRASTRUCTURE_STATIC_TILE_URL } from './layers';
import { MAPBOX_TOKEN } from './mapbox';
import { envToBoolean, getUndefinedRequired } from './utils';

export const INTERNAL_ONLY_SIGNAGE = envToBoolean(process.env.NEXT_PUBLIC_INTERNAL_ONLY_SIGNAGE);

export const SHOW_VIEW_ON_DESKTOP_ALERT = envToBoolean(process.env.NEXT_PUBLIC_SHOW_VIEW_ON_DESKTOP_ALERT);

export const ONE_MSAT_DATE_RANGE = envToBoolean(process.env.NEXT_PUBLIC_ONE_MSAT_DATE_RANGE);

export const GROUP_MAIR_BY_YEAR = envToBoolean(process.env.NEXT_PUBLIC_GROUP_MAIR_BY_YEAR);

export const SHOW_COMPOSITION_OF_EMISSIONS = envToBoolean(process.env.NEXT_PUBLIC_SHOW_COMPOSITION_OF_EMISSIONS);

export const SHOW_RASTER_CI = envToBoolean(process.env.NEXT_PUBLIC_SHOW_RASTER_CI);

export const USE_COMPARISON_VIEW = envToBoolean(process.env.NEXT_PUBLIC_USE_COMPARISON_VIEW);

export const SHOW_FEATURE_IDS = envToBoolean(process.env.NEXT_PUBLIC_SHOW_FEATURE_IDS);

export const SHOW_HISTOGAM = envToBoolean(process.env.NEXT_PUBLIC_SHOW_HISTOGRAM);

/**
 * Ensures that required env variables are set for the Emissions Map.
 */
export const checkEmissionsMapEnv = () => {
    const hasMapsKey = GOOGLE_MAPS_API_KEY || MAPBOX_TOKEN;
    if (!hasMapsKey) {
        throw new Error(
            `Misconfiguration detected.  Either NEXT_PUBLIC_GOOGLE_MAPS_API_KEY or NEXT_PUBLIC_MAPBOX_TOKEN token must be provided, but found none.`
        );
    }

    const requiredEnvVariables = {
        INFRASTRUCTURE_API_BASE_URL,
        INFRASTRUCTURE_DYNAMIC_TILE_URL,
        INFRASTRUCTURE_STATIC_TILE_URL
    };

    const prefixWithNextPublic = (str: string) => `NEXT_PUBLIC_${str}`;
    const missingRequired = getUndefinedRequired(requiredEnvVariables).map(prefixWithNextPublic);
    if (missingRequired.length > 0) {
        throw new Error(`Misconfiguration detected.  Missing env variables: ${missingRequired.join(', ')}
Please review the readme: https://github.com/methanesat-org/msat-ui/tree/main/packages/app#readme`);
    }
};
